/* PWT collection-grid enhancements, extracted from snippets/collection-grid.liquid
   (variant URL-filtering / promo-card positioning / SEO-card positioning).
   Loaded `defer` from sections/main-collection.liquid AFTER the inline
   collection-merchandising-init snippet (parse-time), preserving its RUN ORDER
   CONTRACT (merch reorder must precede promo/SEO positioning). Each module
   self-gates on DOM markers and is idempotent, so it tolerates coexisting with
   a reverted inline copy. Do NOT load on main-collection-quick-add — that
   section's snippet still carries its own (older, single-card) inline copies. */

/* 1. Variant URL filtering — only on grids rendered with show_variants */
(function() {
        if (!document.querySelector('[data-pwt-variant-filter]')) return;
        function getURLArray(name) {
          var params = new URLSearchParams(window.location.search);
          var results = [];
          params.forEach(function(value, key) {
            if (key === name) results.push(value);
          });
          return results;
        }

        function applyFilteringToVariants() {
          var itemList = document.querySelectorAll('.grid__item.grid-product');
          var filterColors = getURLArray('filter.v.option.color');
          var filterSizes = getURLArray('filter.v.option.size');

          for (var i = 0, len = itemList.length; i < len; i++) {
            var item = itemList[i];
            var testColor = item.getAttribute('data-filterable-color');
            var colorPass = true;
            var testSize = item.getAttribute('data-filterable-size');
            var sizePass = true;

            if (filterColors.length > 0 && item.hasAttribute('data-filterable-color')) {
              colorPass = false;
              for (var j = 0; j < filterColors.length; j++) {
                if (testColor === filterColors[j]) { colorPass = true; break; }
              }
            }

            if (filterSizes.length > 0 && item.hasAttribute('data-filterable-size')) {
              sizePass = false;
              for (var j = 0; j < filterSizes.length; j++) {
                if (testSize.includes(' ' + filterSizes[j])) { sizePass = true; break; }
              }
            }

            if (colorPass && sizePass) {
              item.classList.remove('variant-filtered-hidden');
            } else {
              item.classList.add('variant-filtered-hidden');
            }
          }
        }

        // Run once on initial load
        applyFilteringToVariants();

        // Re-run on back/forward navigation
        window.addEventListener('popstate', applyFilteringToVariants);

        // Watch for AJAX filter changes by observing URL changes on the collection container only
        var lastUrl = document.location.href;
        var debounceTimer = null;

        function checkUrlChange() {
          if (document.location.href !== lastUrl) {
            lastUrl = document.location.href;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(applyFilteringToVariants, 300);
          }
        }

        var ajaxContainer = document.getElementById('CollectionAjaxContent');
        if (ajaxContainer) {
          new MutationObserver(checkUrlChange).observe(ajaxContainer, { childList: true, subtree: true });
        }
})();

/* 2. Promo card positioning */
(function() {
        var promos = document.querySelectorAll('.grid-promo-card[data-promo-desktop-order]');
        if (!promos.length) return;
        var grid = promos[0].parentElement;

        function positionPromos() {
          var isMobile = window.innerWidth < 590;
          for (var p = 0; p < promos.length; p++) {
            var promo = promos[p];
            var order = parseInt(promo.getAttribute(
              isMobile ? 'data-promo-mobile-order' : 'data-promo-desktop-order'
            ), 10);
            if (!order || order < 1) continue;

            var items = grid.querySelectorAll(':scope > .grid__item:not(.grid-promo-card):not(.grid-seo-card)');
            var visible = [];
            for (var i = 0; i < items.length; i++) {
              if (items[i].style.display !== 'none' && !items[i].classList.contains('variant-filtered-hidden')) {
                visible.push(items[i]);
              }
            }

            var targetIndex = Math.min(order - 1, visible.length);
            if (targetIndex < visible.length) {
              grid.insertBefore(promo, visible[targetIndex]);
            } else {
              grid.appendChild(promo);
            }
          }
        }

        positionPromos();

        var lastUrl = document.location.href;
        var observer = new MutationObserver(function() {
          if (document.location.href !== lastUrl) {
            lastUrl = document.location.href;
            setTimeout(positionPromos, 350);
          }
        });
        var ajax = document.getElementById('CollectionAjaxContent');
        if (ajax) {
          observer.observe(ajax, { childList: true, subtree: true });
        }
        window.addEventListener('popstate', function() { setTimeout(positionPromos, 50); });
})();

/* 3. SEO card positioning */
(function() {
        var seoCards = document.querySelectorAll('.grid-seo-card[data-seo-desktop-order]');
        if (!seoCards.length) return;
        var grid = seoCards[0].parentElement;

        function positionSeoCards() {
          var isMobile = window.innerWidth < 730;
          for (var s = 0; s < seoCards.length; s++) {
            var seoCard = seoCards[s];
            var orderAttr = seoCard.getAttribute(
              isMobile ? 'data-seo-mobile-order' : 'data-seo-desktop-order'
            );
            var order;
            if (!isMobile && orderAttr && orderAttr.indexOf('-') !== -1) {
              order = parseInt(orderAttr.split('-')[0], 10);
            } else {
              order = parseInt(orderAttr, 10);
            }
            if (!order || order < 1) continue;

            // SEO card spans 2 cols; snap forward so it doesn't leave a gap row
            if (!isMobile) {
              var perRow = parseInt(seoCard.getAttribute('data-per-row') || '4', 10);
              var col = (order - 1) % perRow;
              if (col + 2 > perRow) {
                order = order + (perRow - col);
              }
            }

            var items = grid.querySelectorAll(':scope > .grid__item:not(.grid-promo-card):not(.grid-seo-card)');
            var visible = [];
            for (var i = 0; i < items.length; i++) {
              if (items[i].style.display !== 'none' && !items[i].classList.contains('variant-filtered-hidden')) {
                visible.push(items[i]);
              }
            }

            var targetIndex = Math.min(order - 1, visible.length);
            if (targetIndex < visible.length) {
              grid.insertBefore(seoCard, visible[targetIndex]);
            } else {
              grid.appendChild(seoCard);
            }
          }
        }

        positionSeoCards();

        var lastUrl = document.location.href;
        var observer = new MutationObserver(function() {
          if (document.location.href !== lastUrl) {
            lastUrl = document.location.href;
            setTimeout(positionSeoCards, 350);
          }
        });
        var ajax = document.getElementById('CollectionAjaxContent');
        if (ajax) {
          observer.observe(ajax, { childList: true, subtree: true });
        }
        window.addEventListener('popstate', function() { setTimeout(positionSeoCards, 50); });
})();
